export default {
  message: {
    'activity_windows':'弹窗活动',
    操作时间:"操作时间",
    操作内容:"操作内容",
    门店ID:"门店ID",
    工号:"工号",
    用户名称:"用户名称",
    管理端用户ID:"管理端用户ID",
    客户端用户ID:"客户端用户ID",
    操作来源:"操作来源",
    功能ID:"功能ID",
    模块编号:"模块编号",
    模块分组:"模块分组",
    日志列表: '日志列表',
    hello: '好好学习，天天向上！',
    确认: '确认',
    取消: '取消',
    账号激活: '账号激活',
    输入您的姓名: '输入您的姓名',
    请输入密码: '请输入密码',
    再次确认密码: '再次确认密码',
    请选择性别: '请选择性别',
    保密: '保密',
    男: '男',
    女: '女',
    验证长度: '长度在{0}个字符',
    两次输入密码不一致: '两次输入密码不一致',
    登录: '登录',
    邮箱: '邮箱',
    验证码: '验证码',
    密码: '密码',
    TR小程序管理系统: 'TR小程序管理系统™',
    TR: 'TR小程序管理系统™',
    查看帮助文档: '查看帮助文档',
    修改个人信息: '修改个人信息',
    登出: '登出',
    折叠: '折叠',
    展开: '展开',
    首页: '首页',
    小美首页管理: '首页管理',
    小美福利管理: '福利管理',
    产品: '产品',
    产品热搜榜管理: '产品热搜榜管理',
    产品分类管理: '产品分类管理',
    产品管理: '产品管理',
    品牌: '品牌',
    品牌详情类型管理: '品牌详情类型管理',
    品牌管理: '品牌管理',
    运营工具: '运营工具',
    标签管理: '标签管理',
    标签清洗: '标签清洗',
    第三方平台授权: '第三方平台授权',
    组织架构: '组织架构',
    组织管理: '组织管理',
    员工管理: '员工管理',
    欢迎来到: '欢迎来到@:message.TR',
    收录各品牌产品总量: '收录各品牌产品总量',
    产品总量: '产品总量',
    收录各类型产品总量: '收录各类型产品总量',
    注册用户总量: '注册用户总量',
    用户总量: '用户总量',
    编辑: '编辑',
    刷新: '刷新',
    保存: '保存',
    轮播图管理: '1.轮播图管理',
    新增: '新增',
    筛选: '筛选',
    输入关键字: '输入关键字',
    操作: '操作',
    轮播图片: '轮播图片(750*356)',
    无: '无',
    跳转链接: '跳转链接',
    排序: '排序',
    是否列表显示: '是否列表显示',
    删除确认: '删除确认',
    请确认是否删除该内容: '请确认是否删除该内容',
    删除: '删除',
    返回: '返回',
    确定: '确定',
    图片: '图片',
    请输入链接: '请输入链接',
    是否显示: '是否显示',
    是: '是',
    否: '否',
    优先级排序: '优先级排序(数字越小越靠前)',
    图片资源库: '图片资源库',
    请输入搜索内容: '请输入搜索内容',
    根目录: '根目录',
    搜索结果: '搜索结果',
    上传: '上传',
    创建文件夹: '创建文件夹',
    重命名: '重命名',
    移动: '移 动',
    图片预览: '图片预览',
    拼命加载中: '拼命加载中',
    请入文件夹名称: '请入文件夹名称',
    创建: '创 建',
    点击删除将文件移入回收站: '点击删除，将文件移入回收站',
    选择目标文件夹: '选择目标文件夹',
    个项目: '个项目',
    创建日期: '创建日期:',
    关闭: '关闭',
    选择: '选择',
    您还未选择任何图片: '您还未选择任何图片',
    每次最多上传100个文件: '每次最多上传100个文件',
    上传图片格式: '上传图片只能是 JPG,PNG,GIF 格式!',
    上传图片大小: '上传图片大小不能超过 20MB!',
    您还未选择任何项目: '您还未选择任何项目',
    文件夹: '文件夹',
    图片尺寸: '图片尺寸',
    未找到图片或目录: '未找到图片或目录',
    您还未选择目标路径: '您还未选择目标路径',
    容量: '容量:',
    小美福利信息管理: '小美福利信息管理',
    关于小美: '1. 关于小美',
    顶部图片: '顶部图片(750*503)',
    头像: '头像',
    昵称: '昵称',
    输入50个以内文字: '输入50个以内文字',
    内容: '内容',
    请输入内容: '请输入内容',
    宠粉福利: '2. 宠粉福利',
    新建: '新建',
    请选择: '请选择',
    产品ID: '产品ID',
    产品名称: '产品名称',
    品牌名称: '品牌名称',
    产品图片: '产品图片',
    产品状态: '产品状态',
    商品状态:'商品状态',
    搜索次数: '搜索次数',
    浏览次数: '浏览次数',
    增加搜索次数: '增加搜索次数',
    热搜状态: '热搜状态',
    箭头状态: '箭头状态',
    请确认是否删除该热搜内容: '请确认是否删除该热搜内容',
    导出: '导出',
    请确认是否导出: '请确认是否导出',
    产品热搜榜内容编辑: '产品热搜榜内容编辑',
    修改: '修改',
    产品信息: '1.产品信息',
    选择产品: '选择产品',
    产品描述: '产品描述',
    热搜信息编辑: '2.热搜信息编辑',
    普通: '普通',
    火热: '火热',
    新品: '新品',
    上升: '上升',
    下降: '下降',
    增加搜索量: '增加搜索量',
    创建人: '创建人',
    更新日期: '更新日期',
    更新人: '更新人',
    产品不能为空: '产品不能为空',
    产品列表: '产品列表',
    类型: '类型',
    分类ID: '分类ID',
    分类名称: '分类名称',
    LOGO图片: 'LOGO图片',
    父分类ID: '父分类ID',
    继承分类ID: '继承分类ID',
    请确认是否删除该分类: '请确认是否删除该分类',
    父菜单容器型: '父菜单容器型',
    商品列表型: '商品列表型',
    品牌型: '品牌型',
    数据结构型: '数据结构型',
    产品分类编辑: '产品分类编辑',
    分类主信息: '1.分类主信息',
    输入10个以内汉字: '输入10个以内汉字',
    是否临时分类: '是否临时分类',
    分类轮播图: '2.分类轮播图',
    添加: '添加',
    分类下的产品管理: '3.分类下的产品管理',
    分类下的子分类管理: '3.分类下的子分类管理',
    轮播图管理sel: '轮播图管理',
    名称不能为空: '名称不能为空',
    确认关闭: '确认关闭?',
    未定义: '未定义',
    正常: '正常',
    已下架: '已下架',
    不显示: '不显示',
    请确认是否删除该产品: '请确认是否删除该产品',
    产品详情编辑: '产品详情编辑',
    产品主信息: '1.产品主信息',
    请输入商品名称: '请输入商品名称',
    产品主图: '产品主图',
    请输入产品描述: '请输入产品描述',
    产品轮播图: '2.产品轮播图',
    详情类型ID: '详情类型ID',
    详情类型名称: '详情类型名称',
    品牌详情类型编辑: '品牌详情类型编辑',
    详情类型名称不能为空: '详情类型名称不能为空',
    品牌ID: '品牌ID',
    品牌描述: '品牌描述',
    品牌图片: '品牌图片(700*760)',
    是否外链: '是否外链',
    请确认是否删除该品牌: '请确认是否删除该品牌',
    品牌编辑: '品牌编辑',
    品牌主信息: '1.品牌主信息',
    输入20个以内汉字: '输入20个以内汉字',
    品牌图片sel: '品牌图片',
    是否为外链: '是否为外链',
    品牌详情管理: '2.品牌详情管理',
    品牌详情ID: '品牌详情ID',
    品牌详情类型: '品牌详情类型',
    标题: '标题',
    主图片: '主图片(750px)',
    内容1: '内容1',
    中间图片: '中间图片(750px)',
    内容2: '内容2',
    产品名称不能为空:'产品名称不能为空',
    品牌详情编辑: '品牌详情编辑',
    详情类型: '详情类型',
    主图片sel: '主图片',
    中间图片sel: '中间图片',
    输入关键字搜索: '输入关键字搜索',
    标签ID: '标签ID',
    标签名称: '标签名称',
    标签下的用户数: '标签下的用户数',
    创建标签: '创建标签',
    请输入标签名称: '请输入标签名称',
    编辑标签: '编辑标签',
    请确认是否删除该标签: '请确认是否删除该标签',
    导出用户数据耗时较长请确认是否导出: '导出用户数据耗时较长,请确认是否导出',
    正在导出用户数据: '正在导出用户数据',
    当前状态: '当前状态:',
    下载: '下载',
    该主体的标签数量已达上限: '该主体的标签数量已达上限(100个)，无法继续创建',
    选择标签: '选择标签',
    上传用户: '上传用户',
    提交标签: '提交标签',
    选择需处理的标签: 'Step 1. 选择需处理的标签',
    清空: '清空',
    提交: '提交',
    进行CSV字段名称转换: '进行CSV字段名称转换:',
    开启: '开启',
    CSV对应字段名称: 'CSV对应字段名称',
    设置反向标签: '设置反向标签: ',
    请选择标签ID: '请选择标签ID',
    错误与待处理标签有重复: '错误: 与待处理标签有重复',
    上传用户数据CSV文件: 'Step 2. 上传用户数据CSV文件',
    将文件拖到此处: '将文件拖到此处',
    点击上传: '点击上传',
    只能上传文件: '※ 只能上传 csv / zip 文件',
    下载报告: '下载报告',
    提交数据至微信: 'Step 3. 提交数据至微信',
    提交标签需要较长时间完成: '※ 提交标签需要较长时间完成。请勿刷新页面，耐心等待。',
    编辑转换名称: '编辑转换名称',
    请输入标签转换名称: '请输入标签转换名称',
    正在上传用户数据: '正在上传用户数据',
    导入结果报告: '导入结果报告',
    数量: '数量',
    正在对标签进行清洗: '正在对标签进行清洗',
    清洗结果报告: '清洗结果报告',
    每次最多上传1个文件: '每次最多上传1个文件',
    已确认无误并提交标签吗: '已确认无误并提交标签吗？',
    确认取消: '确认取消？',
    您的编辑还未保存是否离开: '您的编辑还未保存，是否离开？',
    标签列表: '标签列表',
    正在授权: '正在授权....',
    第三方平台授权: '第三方平台授权',
    前往授权: '前往授权',
    授权成功: '授权成功',
    暂无数据: '暂无数据',
    组织: '组织',
    部门: '部门',
    岗位: '岗位',
    员工: '员工',
    名称: '名称:',
    请输入组织名称: '请输入组织名称',
    状态: '状态',
    禁用: '禁用',
    备注: '备注:',
    请输入备注内容: '请输入备注内容',
    组织信息: '组织信息',
    组织名称不能为空: '组织名称不能为空',
    添加组织: '添加组织',
    创建者: '创建者:',
    创建时间: '创建时间:',
    编辑者: '编辑者:',
    编辑时间: '编辑时间:',
    父级类型: '父级类型:',
    父级对象: '父级对象:',
    部门信息: '部门信息',
    总部: '总部',
    部门名称不能为空: '部门名称不能为空',
    请选择父级对象: '请选择父级对象',
    添加部门: '添加部门',
    所属部门: '所属部门:',
    权限信息: '权限信息',
    权限设置: '权限设置:',
    全选: '全选',
    员工信息: '员工信息',
    添加员工: '添加员工',
    工作名: '工作名',
    联系方式: '联系方式',
    移除: '移除',
    岗位名称不能为空: '岗位名称不能为空',
    请选择所属部门: '请选择所属部门',
    岗位信息: '岗位信息',
    添加岗位: '添加岗位',
    未激活: '未激活',
    被冰冻: '被冰冻',
    员工状态: '员工状态',
    姓名: '姓名',
    手机: '手机',
    性别: '性别',
    工作名称: '工作名称',
    部门ID: '部门ID',
    部门名称: '部门名称',
    岗位ID: '岗位ID',
    岗位名称: '岗位名称',
    工作名称不能为空: '工作名称不能为空',
    员工名称不能为空: '员工名称不能为空',
    请输入搜索员工手机号: '请输入搜索员工手机号',
    请输入搜索手机号: '请输入搜索手机号',
    权限: '权限',
    外部用户: '外部用户',
    客服: '客服',
    经理: '经理',
    超级管理员: '超级管理员',
    手机号码: '手机号码',
    照片: '照片',
    员工列表: '员工列表',
    当前搜索手机号不存在点击确认添加: '当前搜索手机号不存在，点击确认添加',
    注册用户: '注册用户',
    账号验证: '账号验证',
    个人信息: '个人信息',
    验证码和确认提交: '验证码和确认提交',
    完成: '完成',
    账号: '账号',
    电话: '电话',
    请选择地区: '请选择地区',
    请输入电话号码: '请输入电话号码',
    获取验证码: '获取验证码',
    秒后再次获取验证码: '秒后再次获取验证码',
    注册账号成功: '注册账号成功',
    登录账号: '登录账号：',
    默认密码: '默认密码',
    退出: '退出',
    上一步: '上一步',
    下一步: '下一步',
    再次注册: '再次注册',
    确认注册: '确认注册',
    请输入名字: '请输入名字',
    请输入有效的电话号码: '请输入有效的电话号码',
    请输入验证码: '请输入验证码',
    请输入账号名: '请输入账号名',
    账号名长度: '账号名长度3-36，可包含数字、字母、下划线且未注册',
    用户中心: '用户中心',
    设置: '设置',
    选择头像: '选择头像',
    确认修改: '确认修改',
    重置: '重置',
    修改注册电话: '修改注册电话',
    修改账号密码: '修改账号密码',
    原密码: '原密码',
    新密码: '新密码',
    再次输入: '再次输入',
    请输入旧密码: '请输入旧密码',
    请输入新密码: '请输入新密码',
    请再次输入新密码: '请再次输入新密码',
    两次输入的新密码不一致: '两次输入的新密码不一致',
    注册电话: '注册电话',
    修改密码: '修改密码',
    上传头像图片格式只能为: '上传头像图片格式只能为png/jpg/jpeg',
    图片大小不能超过2mb: '图片大小不能超过2mb',
    账号密码: '账号密码',
    企业设置: '企业设置',
    test: 'test',
    开放平台: '开放平台',
    接口比例: '可用接口数/接口总数',
    API调取统计: 'API调取统计',
    每秒可调用接口次数: '每秒可调用接口次数',
    重置时间: '重置时间',
    API认证信息: 'API认证信息',
    查看API文档: '查看API文档',
    查看API说明: '查看API说明',
    白名单: '白名单',
    添加IP或域名: '添加IP或域名',
    显示: '显示',
    隐藏: '隐藏',
    重置accessKeySecret: '重置accessKeySecret',
    安全提示: '安全提示：请妥善保管API认证信息，切记勿把accessKeySecret交给不信任的第三方。避免对该页面进行截图',
    权限提示: '由于子账号受数据权限影响，所以通过子账号access-key调取回收的数据会受到数据权限控制',
    ip域名备注: '注：最少添加一个IP或者域名，否则接口调取会报错',
    ip域名提示: '域名无需添加http://或者https://',
    最多可以创建5个服务器IP或域名: '最多可以创建5个服务器IP或域名',
    域名: '域名',
    删除提醒: '删除提醒',
    好的: '好的',
    可用接口: '可用接口',
    划线的为不可用接口若要使用请联系客户经理: '划线的为不可用接口，若要使用请联系客户经理',
    模块: '模块',
    接口: '接口',
    速流限制: '速流限制',
    已调取次数: '已调取次数/剩余次数',
    天: '天',
    最大调取: '最大调取',
    次: '次',
    元数据: '元数据',
    属性名: '属性名',
    字段含义: '字段含义',
    mongo字段名: 'mongo字段名',
    fieldid: 'fieldid',
    字段类型: '字段类型',
    数据来源: '数据来源',
    预制状态: '预制状态',
    父字段名称: '父字段名称',
    长度: '长度',
    聚合字段: '聚合字段',
    显示标记: '显示标记',
    主键标记数字越大优先级越高: '主键标记',
    验证手机号: '验证手机号',
    验证注册信息: '验证注册信息',
    会员中心: '会员中心',
    会员管理: '会员管理',
    角色管理: '角色管理',
    角色id: '角色id',
    角色名: '角色名',
    角色描述: '角色描述',
    级别: '级别',
    类别: '类别',
    降级id: '降级id',
    降级显示: '降级显示',
    降级名: '降级名',
    降级描述: '降级描述',
    角色管理编辑: '角色管理编辑',
    角色主信息: '角色主信息',
    角色logo: '角色logo',
    角色信息: '角色信息',
    添加角色条件: '添加角色条件',
    编辑条件表达式: '编辑条件表达式',
    是否开启降级规则: '是否开启降级规则',
    不满足后名字: '不满足后名字',
    请输入描述: '请输入描述',
    不满足后信息: '不满足后信息',
    不满足条件角色logo: '不满足条件角色logo',
    用户id: '用户id',
    用户角色id: '用户角色id',
    真实名: '真实名',
    注册时间: '注册时间',
    初次登录时间: '初次登录时间',
    国家: '国家',
    省份: '省份',
    城市: '城市',
    未知: "未知",
    会员信息详情: '会员信息详情',
    会员信息: '会员信息',
    活动记录: '活动记录',
    浏览记录: '浏览记录',
    会员卡: '会员卡',
    购物车: "购物车",
    优惠券: '优惠券',
    收藏夹: '收藏夹',
    推送人: '推送人',
    订单: '订单',
    积分: '积分',
    活动奖励: '活动奖励',
    活动分类:'活动分类',
    活动分类id:'活动分类id',
    积分商城商品:'积分商城商品',
    openid: 'openid',
    unionID: 'unionID',
    shopID: 'shopID',
    userKey: "userKey",
    语言: '语言',
    用户昵称: "用户昵称",
    用户名: '用户名',
    用户状态: '用户状态',
    customFields: 'customFields',
    生日: '生日',
    标签: '标签',
    居住城市: '居住城市',
    平台类型: '平台类型',
    登录ID: '登录ID',
    邀请人ID: '邀请人ID',
    邀请方式: '邀请方式',
    最近登录时间: '最近登录时间',
    grouping: 'grouping',
    identityCard: 'identityCard',
    identityCardImg: 'identityCardImg',
    自定义主页: '自定义主页',
    条件表达式: '条件表达式',
    分群名称: '分群名称',
    选择分组: '选择分组',
    条件簇: "条件簇",
    且: '且',
    或: '或',
    请选择添加的事件类型: '请选择添加的事件类型',
    点击添加: '点击添加',
    用户数据: '用户数据',
    订单数据: '订单数据',
    事件数据: '事件数据',
    表单数据: '表单数据',
    优惠券数据: '优惠券数据',
    至: "至",
    选择日期时间: '选择日期时间',
    在: '在',
    天: '天',
    等于: '等于',
    不等于: '不等于',
    大于: '大于',
    小于: '小于',
    有值: '有值',
    没值: '没值',
    区间: '区间',
    真: '真',
    伪: '伪',
    包含: "包含",
    不包含: '不包含',
    属于: "属于",
    不属于: '不属于',
    当前时间点: "当前时间点",
    低代码编辑平台主页: '低代码编辑平台主页',
    配置选项: '配置选项',
    整体布局: '整体布局',
    单项配置: '单项配置',
    侧边栏配置: '侧边栏配置',
    恢复: '恢复',
    文字框编辑区域: '文字框编辑区域',
    用户事件: '用户事件',
    会员状态: '会员状态',
    事件类型: '事件类型',
    微信openID: '微信openID',
    页面路径: '页面路径',
    描述: '描述',
    source: 'source',
    masterAppID: 'masterAppID',
    编辑日期: 'editDate',
    微信unionID: '微信unionID',
    外部平台ID: "外部平台ID",
    地理位置: "地理位置",
    事件内容: '事件内容',
    数据ID1: "数据ID1",
    数据ID2: "数据ID2",
    数据ID3: "数据ID3",
    数据ID4: "数据ID4",
    数据ID5: "数据ID5",

    完成度: "完成度",

    日期类型: '日期类型',
    发生时间: '发生时间',
    小美配置项: "配置项",
    小美配置管理: '配置管理',
    首页弹出框图片: '首页弹出框图片',
    弹出框图片: '弹出框图片',
    关注图片: "关注图片",
    会员身份: '会员身份',
    appID: 'appID',
    全部行为: '全部行为',
    点击行为: '点击行为',
    进入页面: '进入页面',
    离开页面: '离开页面',
    点击活动: '点击活动',
    点击产品: '点击产品',
    点击底部菜单: '点击底部菜单',
    用户分享: "用户分享",
    点击链接: '点击链接',
    搜索: '搜索',
    点击banner: '点击banner',
    外部页进入: '外部页进入',
    点击关注: '点击关注',
货品管理:'货品管理',
    跳转外部页: '跳转外部页',
    跳转外部小程序: '跳转外部小程序',
    跳转视频号: '跳转视频号',
    文章阅读完成: '文章阅读完成',
    页面访问时长: '页面访问时长',
    资源位点击: '资源位点击',
    用户注册: '用户注册',
    完善信息: '完善信息',
    订阅消息: '订阅消息',
    添加心愿: '添加心愿',
    填写表单: '填写表单',
    点赞: '点赞',

    预约设置: '预约设置',
    基础信息设置: 'Step 1.基础信息设置',
    参加条件设置: 'Step 2.参加条件设置',
    完成条件设置: 'Step 3.完成条件设置',
    领取奖励设置: 'Step 4.领取奖励设置',
    活动设置: '活动设置',
    活动: "活动",
    商品库存: '商品库存',
    货品名称:'货品名称',
    货品详情编辑:'货品详情编辑',
    货品图片:'货品图片',
    货品种类:'货品种类',
    门店管理: '门店管理',
    活动名称: '活动名称',
    活动id: '活动id',
    自定义url: '自定义url',
    门店: '门店',
    活动图片1: '活动图片750*min（500）',
    兑换开始时间:'兑换开始时间',
    兑换结束时间:'兑换结束时间',
    上市发布时间:'上市发布时间',
    产品名称2:'产品名称2',
    货架名称2:'货架名称2',
    货架名称1:'货架名称1',
    产品名称1:'产品名称1',
    货架详情编辑:'货架详情编辑',
    请输入货架名称:'请输入货架名称',
    请输入货架描述:'请输入货架描述',
    货架主图:'货架主图',
    货架描述:'货架描述',
    货架状态:'货架状态',
    活动图片: '活动图片',
    开始日期: '开始日期',
    结束日期: "结束日期",
    参与次数统计: '参与次数统计',
    完成次数统计: '完成次数统计',
    小美页面管理: '页面管理',
    跳转类型: '跳转类型',
    跳转微信id: "跳转微信id",
    分类下的子分类管理: '分类下的子分类管理',
    产品说明: '2.产品说明',
    参加序列号: '参加序列号',
    预约开始时间: '预约开始时间',
    预约结束时间: '预约结束时间',
    openID: "openID",
    预约序列号: "预约序列号",
    同行人数: '同行人数',
    批量到货通知:'批量到货通知',
    userID: 'userID',
    选择日期: '选择日期',
    门店id: '门店id',
    门店名: '门店名',
    是否完成: '是否完成',
    活动类型: '活动类型',
    奖品库存: '奖品库存',
    订单管理: '订单管理',
    openAPI接口管理: 'openAPI接口管理',
    查阅配表: '接口id详细信息，请查阅配表',
    添加接口限制: '添加接口限制',
    货架ID:'货架ID',
    门店内部库存:'门店内部库存',
    门店外部库存:'门店外部库存',
    接口ID: '接口ID',
    限制次数: '限制次数',
    商家名: '商家名',
    角色优先级:'角色优先级',
    商家描述: '商家描述',
    添加openApi调用限制: '添加openApi调用限制',
    积分管理: '积分管理',
    积分组: '积分组',
    积分获取: '积分获取',
    积分组管理: '积分组管理',
    分组ID: '分组ID',
    分组名称: '分组名称',
    积分规则说明: '积分规则说明',
    有效期类型: '有效期类型',
    积分组详情编辑: "积分组详情编辑",
    积分组信息: '积分组信息',
    请输入积分规则说明: '请输入积分规则说明',
    有效期类型: '有效期类型',
    请输入有效期参数: '请输入有效期参数',
    有效期参数: '有效期参数',
    获取积分上限: '获取积分上限',
    是否有获取上限: '是否有获取上限',
    积分组编辑: '积分组编辑',
    获取积分通知方式: '获取积分通知方式',
    获取积分消息内容: '获取积分消息内容',
    请输入获取积分消息内容: '请输入获取积分消息内容',
    消费积分通知方式: '消费积分通知方式',
    消费积分消息内容: '消费积分消息内容',
    请输入消费积分消息内容: '请输入消费积分消息内容',
    积分分组名称: '积分分组名称',
    积分分组ID: '积分分组ID',
    积分获取方式管理: '积分获取方式管理',
    积分获取方式: '积分获取方式',
    获取方式ID: '获取方式ID',
    获取积分: '获取积分',
    触发类型: '触发类型',
    需触发次数: '需触发次数',
    限制次数: '限制次数',
    限制类型: '限制类型',
    限制间隔: '限制间隔',
    备注信息: '备注信息',
    积分获取方式编辑: '积分获取方式编辑',
    请确认是否删除该分组: '请确认是否删除该分组',
    请确认是否删除该获取方式: '请确认是否删除该获取方式',
    积分获取方式ID: '积分获取方式ID',
    请输入: '请输入',
    是否有次数限制: '是否有次数限制',
    积分获取记录: '积分获取记录',
    积分消费记录: '积分消费记录',
    用户积分管理: '用户积分管理',
    MGM活动管理: 'MGM活动管理',
    MGM活动编辑: "MGM活动编辑",
    MGM活动ID: 'MGM活动ID',
    请确认是否删除: '请确认是否删除',
    活动海报编辑: '活动海报编辑',
    活动备注: '活动备注',
    背景图片: '背景图片',
    参加条件: '参加条件',
    分享图片生成器编辑: '分享图片生成器编辑',
    激活码大小: '激活码大小',
    激活码位置X轴: '激活码位置X轴',
    激活码位置Y轴: '激活码位置Y轴',
    太阳码大小: '太阳码大小',
    太阳码位置X轴: '太阳码位置X轴',
    太阳码位置Y轴: '太阳码位置Y轴',
    活动ID: '活动ID',
    推荐标识: '推荐标识',
    产品推荐搜索关键词管理: '产品推荐搜索关键词管理',
    关键词: '关键词',
    请确认是否删除该推荐关键词: '请确认是否删除该推荐关键词',
    推荐关键词编辑: '推荐关键词编辑',
    关键词主信息: '关键词主信息',
    请输入产品型号:'请输入产品型号',
    Banner管理: 'Banner管理',
    是否首页默认: '是否首页默认',
    推荐搜索: '推荐搜索',
    推荐活动: '推荐活动',
    关键词和类型不能为空: '关键词和类型不能为空',
    跳转url: '跳转url',
    输入推荐活动跳转的url: '输入推荐活动跳转的url',
    订阅消息: '订阅消息',
    MGM活动排行榜: 'MGM活动排行榜',
    MGM活动: 'MGM活动',
    请选择MGM活动: "请选择MGM活动",
    排名: '排名',
    邀请人数: '邀请人数',
    积分排行榜: '积分排行榜',
    请选择积分分组: '请选择积分分组',
    文章管理: '文章管理',
    隐私政策管理: '隐私政策管理',
    隐私政策: '隐私政策',
    隐私政策编辑: '隐私政策编辑',
    隐私政策ID: '隐私政策ID',
    隐私政策标题: '隐私政策标题',
    隐私政策内容: '隐私政策内容',
    隐私政策版本: '隐私政策版本',
    隐私政策内容: '隐私政策内容',
    是否使用该隐私政策: '是否使用该隐私政策',
    是否使用:'是否使用',
    协议类型:'协议类型',
    隐私协议:'隐私协议',
    条件条款:'条件条款',
    会员细则:'会员细则',
    协议内容:'协议内容',
    生效:'生效',
    不生效:'不生效',
    版本:'版本',
    文章: '文章',
    视频: '视频',
    PDF: 'PDF',
    优先级: '优先级排序(数字越大越靠前)',
    文章ID: '文章ID',
    文章标题: '文章标题',
    banner图: 'banner图',
    文章编辑: '文章编辑',
    banner图片: 'banner图片',
    PDF主图: 'PDF主图',
    文章类型: '文章类型',
    分类: '分类',
    文章内容: '文章内容',
    文章内容编辑: '文章内容编辑',
    word上传: 'word上传',
    PDF简介: 'PDF简介',
    留言板管理: '留言板管理',
    切换置顶: '切换置顶',
    切换锁定: '切换锁定',
    发送: '发送',
    兴趣标签: '兴趣标签',
    归属: '*归属',
    秒杀栏位:'秒杀栏位',
    测试用:'测试用',
    普通分类:'普通分类',
    积分商城分类:'积分商城分类',
    标签分组: '标签分组',
    标签分组编辑: '标签分组编辑',
    标签分组ID: '标签分组ID',
    标签分组名称: '标签分组名称',
    标签分组列表: '标签分组列表',
    标签分组详情: '标签分组详情',
    兴趣标签列表: '兴趣标签列表',
    兴趣标签ID: '兴趣标签ID',
    兴趣标签标题: '兴趣标签标题',
    兴趣标签详情: '兴趣标签详情',
    滚动信息内容: '滚动信息内容',
    购买所需会员等级:'购买所需会员等级',
    购买所需最小等级:'购买所需最小等级',
    查看所需最小等级:'查看所需最小等级',
    查看所需会员等级:'查看所需会员等级',
    用户维度: '用户维度',
    内容维度: '内容维度',
    我的维度: '我的维度',
    搜索维度: '搜索维度',
    资源位: '资源位',
    场景: '场景',
    推荐搜索关键词管理:'推荐搜索关键词管理',
    分类管理:'分类管理',
    员工编号:'员工编号',
    姓名:'姓名',
    员工姓名:'员工姓名',
    手机:'手机',
    职位:'职位',
    在职状态:'在职状态',
    禁用状态:'禁用状态',
    状态:'状态',
    更新日期:'更新日期',
    在职:'在职',
    离职:'离职',
    未定义:'未定义',
    手机:'手机',
    职位:'职位',
    关联门店:'关联门店',
    基本信息编辑:'基本信息编辑',
    店员编号:'店员编号',
    openID:'openID',
    unionID:'unionID',
    最后登录:'最后登录',
    激活日期:'激活日期',
    创建者:'创建者',
    创建日期:'创建日期',
    更新者:'更新者',
    更新日期:'更新日期',
    商品管理:'商品管理',
    商品详情编辑:'商品详情编辑',
    商品主信息:'商品主信息',
    商品ID:'商品ID',
    商品货架ID:'商品货架ID',
    appID:'appID',
    商品编号:'商品编号',
    条形码:'条形码',
    商品图片:'商品图片',
    商品名称:'商品名称',
    重量:'重量',
    buypoints:'buypoints',
    购买积分:'购买积分',
    积分价格:'积分价格',
    大小:'大小',
    打包大小:'打包大小',
    生产地:'生产地',
    门店类型:'门店类型',
    实体店:'实体店',
    虚拟店:'虚拟店',
    仓库:'仓库',
    测试状态:'测试状态',
    领取方式:'领取方式',
    邮寄:'邮寄',
    自提:'自提',
    上架时间:'上架时间',
    库存类型:'库存类型',
    快递发货库存类型:'快递发货库存类型',
    不计算库存:'不计算库存',
    普通库存:'普通库存',
    外部库存:'外部库存',
    仓库库存:'仓库库存',
    双重检查库存:'双重检查库存(仓库总量+门店外部系统)',
    库存编号:'库存编号',
    邮费积分:'邮费积分',
    核销过期类型:'核销过期类型',
    核销有效时间:'核销有效时间',
    逾期能否核销:'逾期能否核销',
    逾期后不可核销:'逾期后不可核销',
    逾期后可核销:'逾期后可核销',
    商品种类:'商品种类',
    是否使用门店价格:'是否使用门店价格',
    出售价格:'出售价格',
    获得积分:'获得积分',
    包装大小:'包装大小',
    编辑日期:'编辑日期',
    不使用:'不使用',
    使用:'使用',
    最小进货数量:'最小进货数量',
    统一进货价:'统一进货价',
    型号:'型号',
    获得积分组:'获得积分组',
    消费积分组:'消费积分组',
    商品列表:'商品列表',
    测试数据:'测试数据',
    已删除:'已删除',
    优惠券管理:'优惠券管理',
    上架时间:'上架时间',
    预上架时间:'预上架时间',
    预下架时间:'预下架时间',
    邮费积分:'邮费积分',
    核销过期类型:'核销过期类型',
    永久有效:'永久有效',
    固定时间:'固定时间',
    领取后有效时间:'领取后有效天数',
    领取后有效天数:'领取后有效天数',
    逾期后不可核销:'逾期后不可核销',
    逾期后可核销:'逾期后可核销',
    测试:'测试',
    心动魅粉:'心动魅粉',
    新晋魅粉:'新晋魅粉',
    高阶魅粉:'高阶魅粉',
    头号魅粉:'头号魅粉',
    批次标签:'批次标签',
    商品编号不能为空:'商品编号不能为空',
    消费积分不能为空:'消费积分不能为空',
    快递发货库存类型不能为空:'快递发货库存类型不能为空',
    门店自提库存类型不能为空:'门店自提库存类型不能为空',
    商品状态不能为空:'商品状态不能为空',
    是否walmartGo分类:'是否walmartGo分类',
  }
}



// WEBPACK FOOTER //
// ./src/language/cn.js